import {useContext, useState} from "react";
import {UserContext} from "./UserContext";
import {useNavigate} from "react-router-dom";
import axios from "axios";

const SignIn = () => {
    const {set_access_token,userData,backEndUrl} = useContext(UserContext)
    const[email,setEmail] = useState("")
    const[password,setPassword] = useState("")
    const[loading,setLoading] = useState("")
    const[error,setError] = useState("")
    const navigate = useNavigate()

    const SubmitForm = async (e) =>{
        setError("")
        setLoading("")
        e.preventDefault()
        if (!email || !password){
            setError("Please fill all the required fields.")
            return
        }
        setLoading("Please wait as your request is being processed.")
        try {
            const userInfo = new FormData();
            userInfo.append("email",email)
            userInfo.append("password",password)

            const response = await axios.post(`${backEndUrl}/signin`,userInfo)
            setEmail("")
            setPassword("")
            if(response.data.access_token){
                localStorage.setItem("access_token",JSON.stringify(response.data.access_token))
                set_access_token(response.data.access_token)
                navigate("/")
            }else {
                setLoading("")
                setError(response.data.message)
            }
        }catch (error){
            setLoading("")
            setError(error.message)
        }

    }

    return(
        <section className="section">
            <div className="section-container auth-layout">
                {!userData ? (
                    <div className="auth-card">
                        <h1>Sign in to continue</h1>
                        <p className="body-text">Access the private workspace, manage projects and review conversations.</p>
                        {loading && <div className="status-banner info">{loading}</div>}
                        {error && <div className="status-banner danger">{error}</div>}
                        <form onSubmit={SubmitForm}>
                            <label className="form-field">
                                <span>Email</span>
                                <input type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@example.com" required/>
                            </label>
                            <label className="form-field">
                                <span>Password</span>
                                <input type="password" value={password} onChange={e =>setPassword(e.target.value)} placeholder="••••••••" required/>
                            </label>
                            <button className="btn btn-accent w-100" type="submit">Sign in</button>
                        </form>
                    </div>
                ) : (
                    <div className="auth-card">
                        <h1>You’re already signed in</h1>
                        <p className="body-text">
                            Currently logged in as <strong>{userData.full_name}</strong>. You can head back to the homepage to keep exploring.
                        </p>
                        <button className="btn btn-secondary" onClick={()=>navigate("/")}>Back to homepage</button>
                    </div>
                )}
            </div>
        </section>
    )

}

export default SignIn